/** Canonical display labels for known malware categories (keys are normalized). */
const CATEGORY_LABEL_OVERRIDES: Record<string, string> = {
  rat: 'RAT',
  pws: 'PWS',
  rmmtool: 'RMM Tool',
}

function normalizeCategoryLabelKey(label: string): string {
  return label.trim().replace(/\s+/g, '').toLowerCase()
}

/**
 * Formats pie-chart category names for legend and data labels.
 * Exact matches (ignoring spaces/case) map to RAT, PWS, or RMM Tool; others get sentence case.
 */
export function formatMalwareCategoryLabel(raw: string): string {
  const trimmed = raw.trim()
  if (!trimmed) return trimmed

  const override = CATEGORY_LABEL_OVERRIDES[normalizeCategoryLabelKey(trimmed)]
  if (override) return override

  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase()
}
